export default __webpack_public_path__ + "static/media/or.c02b4ac4.svg";